import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlanosService {

  constructor(private api: ApiService) {}

  fetchPlanos() {
    const endpoint = 'Plan';
    const route = environment.API_URL + endpoint;
    return this.api.get$(route);
  }
}
